<script>
import GuestDocumentationMixin from '@/mixins/guestdocumentation'

export default {
  name: 'GuestDocumentationDestinationAmerica',
  mixins: [ GuestDocumentationMixin ],
  computed: {}
}
</script>

<style lang="scss" scoped>
@import './bootstrap.scss';
@import './main.scss';
</style>

<template>
  <h1>&nbsp;</h1>
</template>
